import styled from "styled-components"
import { colors } from "../../lib/colors"

export interface settings_props {
  showSettings: boolean
  isLoading?: any
  tempRemoveComponents?: boolean
}

export const SettingsWrapper = styled.div<settings_props>`
  width: 100%;
  height: ${({ showSettings }) => (showSettings ? "100%" : "0px")};
  background: rgba(11, 10, 13, 0.96);
  position: fixed;
  top: 32px;
  left: 0;
  color: white;
  transition: all 0.167s ease;
  z-index: 100;
  user-select: none;
  @media (min-width: 768px) {
    display: none;
  }
`

export const SettingsPageContainer = styled.div<settings_props>`
  padding: 20px;
  opacity: ${({ showSettings }) => (showSettings ? 1 : 0)};
  transition: ${({ showSettings }) =>
    showSettings ? "all 0.3s ease 0.167s" : "all 0.3s ease"};
  pointer-events: ${({ showSettings }) => (showSettings ? "auto" : "none")};
`
